module.exports = __webpack_public_path__ + "static/img/2_1_1_2.b54b360a.jpg";